import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, PlayCircle, Clock, BrainCircuit, Apple } from 'lucide-react';
export function CourseContent() {
  const contents = [{
    icon: BookOpen,
    title: 'Plan de entrenamiento de 30 días',
    desc: 'El paso a paso exacto para cada día.'
  }, {
    icon: PlayCircle,
    title: 'Más de 30 ejercicios explicados',
    desc: 'Para que los hagas con la técnica correcta.'
  }, {
    icon: Clock,
    title: 'Rutinas de 20 minutos',
    desc: 'Diseñadas para maximizar resultados en poco tiempo.'
  }, {
    icon: BrainCircuit,
    title: 'Mentalidad y hábitos',
    desc: 'Cómo hackear tu mente para no abandonar.'
  }, {
    icon: Apple,
    title: 'Fundamentos de nutrición',
    desc: 'Bases simples para acompañar tu entrenamiento.'
  }];
  return <section className="py-24 bg-white" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-45">
          {/* Image/Mockup side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-46">
            <div className="aspect-square rounded-3xl overflow-hidden bg-gray-100 relative" data-id="element-47">
              <img src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&q=80&w=1000" alt="Contenido del ebook" className="w-full h-full object-cover opacity-90" data-id="element-48" />
              <div className="absolute inset-0 bg-gradient-to-tr from-rose-500/20 to-transparent" data-id="element-49" />
            </div>

            {/* Floating element */}
            <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-2xl shadow-xl border border-gray-100 max-w-xs hidden md:block" data-id="element-50">
              <div className="flex items-center gap-4" data-id="element-51">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-52">
                  <BookOpen className="w-6 h-6 text-green-600" data-id="element-53" />
                </div>
                <div data-id="element-54">
                  <p className="font-bold text-gray-900" data-id="element-55">Acceso Inmediato</p>
                  <p className="text-sm text-gray-500" data-id="element-56">Formato Digital PDF</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content list side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-57">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-58">
              Qué incluye{' '}
              <span className="text-rose-500" data-id="element-59">Ejercitá en Casa</span>
            </h2>
            <p className="text-lg text-gray-600 mb-10" data-id="element-60">
              Todo lo que necesitás para transformar tu cuerpo y mente,
              organizado de forma simple y directa.
            </p>

            <div className="space-y-6" data-id="element-61">
              {contents.map((item, index) => <motion.div key={index} className="flex gap-4" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} data-id="element-62">
                  <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center flex-shrink-0 border border-rose-100" data-id="element-63">
                    <item.icon className="w-6 h-6 text-rose-500" data-id="element-64" />
                  </div>
                  <div data-id="element-65">
                    <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-66">
                      {item.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-67">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}